import React from 'react';
import {Highlight} from 'react-instantsearch/dom';
import * as logo from '../images/star-crown.png';
import * as langtons from '../images/langtons.jpg';
import * as noImage from '../images/no-image.png';
import * as twitter from '../images/twitter@2x.png';
import * as facebook from '../images/facebook@2x.png';
import * as mail from '../images/mail@2x.png';
import * as download from '../images/download@2x.png';

import qs from 'qs';
import encode from 'encode-3986';
import Lightbox from 'lightbox-react';
//import ImageZoom from 'react-medium-image-zoom'

class HitComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      animate: false,
      photoIndex: 0,
      isOpen: false
    };
  }
  componentDidMount() {
    // Added requestAnimationFrame
    requestAnimationFrame(() => {
      this.setState({ animate: true });
    });
  }

  render () {
  const {searchState, hit} = this.props
  //const url = `${window.location.pathname}?${encode(qs.stringify(searchState))}`
  //const url = `/index.php/about/history/langtons-para-tawny-timeline/?${encode(qs.stringify(searchState))}`
  const url = `?${encode(qs.stringify(searchState))}`
  //const url = `${window.location.pathname}?${qs.stringify(searchState)}`
  //const url = "/index.php/about/history/langtons-para-tawny-timeline"
  const {
    photoIndex,
    isOpen,
    } = this.state;
  const img = `https://www.seppeltsfield.com.au/zhistory/${hit.image_file_name_all_in_png_format}.jpg`
  //const img = qs.stringify(imgObject)
  return (
    <article className="product" style={ {
          opacity: this.state.animate ? 1 : 0,
          visibility: this.state.animate ? 'visible' : 'hidden',
        } }>
      <header>
        <h2 className="product__vintage test">
          {/* <Highlight attributeName="vintage" hit={hit}/> */}
          {hit.vintage}
        </h2>
      </header>
     {/* <a href={`https://www.seppeltsfield.com.au/zhistory/${hit.image_file_name_all_in_png_format}.jpg`} target="_top" title="View larger image"> */}
      <img onClick={() => this.setState({ isOpen: true })} className="product__image" alt={`${hit.vintage}`} src={`https://www.seppeltsfield.com.au/zhistory/${hit.image_file_name_all_in_png_format}.jpg`} onError={(e)=>{e.target.src=noImage; e.target.className="product__image no-image"}}   />
    {/* </a> */}
      <div className="product__content">
        <div className="product__specs">
          <h3 className="product__name">
            <Highlight attributeName="wine_name" hit={hit}/>
            <span className="product__bottle-number">
              <Highlight attributeName="winery" hit={hit}/>
            </span>
            {!!(hit.series_set_commemorative_branding)
              ?
              <span className="product__bottle-number">
                <Highlight attributeName="series_set_commemorative_branding" hit={hit}/>
              </span>
              :
              ""}
          </h3>
          {!!(hit.bottling_number)
            ?
            <p className="product__bottle-number">
              <span>Number Series {hit.bottling_number}</span>
              {/* <Highlight attributeName="bottling_number" hit={hit}/> */}
            </p>
            :
            ""}
        </div>
        <div className="product__actions">
          <div className="product__actions__valuation">
            <img src={langtons} className="product__actions__logo langtons-logo" alt="Langtons" />
            <a href={`mailto:valuations@langtons.com.au?subject=Valuation%20Enquiry%20from%20Langton%27s%20Para%20Tawny%20Timeline&body=Bottle%20Information%0D%0A%0D%0A${hit.wine_name}%20${hit.vintage}%20${hit.series_set_commemorative_branding}%0D%0AFirst%20Released:%20${hit.year_first_released}%0D%0APackaging:%20${hit.bottle_sizes}%20${hit.bottling_information}%20${hit.bottle_shape_or_colour}%0D%0A%0D%0ALink%20to%20Para%20Tawny%20Timeline:%0D%0Ahttps://www.seppeltsfield.com.au/index.php/about/history/langtons-para-tawny-timeline${url}`} className="button">Get a valuation</a>
          </div>
          {!!(hit.hyperlink)
            ?
            <div className="product__actions__availability">
              <img src={logo} className="product__actions__logo seppeltsfield-logo" alt="Seppeltsfield" />
              <a href={`${hit.hyperlink}`} className="button button--dark" target="_blank" rel="noopener noreferrer">Buy Now</a>
            </div>
            :
            <div className="product__actions__availability">
              <img src={langtons} className="product__actions__logo langtons-logo" alt="Langtons" />
              <a href={`https://www.langtons.com.au/search?query=${hit.vintage}%20${hit.winery}`} className="button" target="_blank" rel="noopener noreferrer">Search availability</a>
            </div>
            }

        </div>
        <div className="product__share-btns">
          <ul className="product__share-btns__wrapper hi-icon-wrap hi-icon-effect-8">
            <li className="sharing__item hi-icon">
              <a href={`https://www.facebook.com/sharer/sharer.php?u=https://www.seppeltsfield.com.au/index.php/about/history/langtons-para-tawny-timeline${url}`} title="Share on Facebook" target="_blank" rel="noopener noreferrer">
                <img src={facebook} className="socials socials--facebook" alt="facebook" />
              </a>
            </li>
            <li className="sharing__item hi-icon">
              <a href={`https://twitter.com/intent/tweet?url=https://www.seppeltsfield.com.au/index.php/about/history/langtons-para-tawny-timeline${url}`} target="_blank" rel="noopener noreferrer" title="Tweet">
                <img src={twitter} className="socials socials--twitter" alt="twitter" />
              </a>
            </li>
            <li className="sharing__item hi-icon">
              {/* <a href={`mailto:?subject=&body=https://www.seppeltsfield.com.au/index.php/about/history/langtons-para-tawny-timeline${url}`} title="Send email"> */}
              <a href={`mailto:?subject=Langton%27s%20Para%20Tawny%20Timeline&body=Bottle%20Information%0D%0A%0D%0A${hit.wine_name}%20${hit.vintage}%20${hit.series_set_commemorative_branding}%0D%0AFirst%20Released:%20${hit.year_first_released}%0D%0APackaging:%20${hit.bottle_sizes}%20${hit.bottling_information}%20${hit.bottle_shape_or_colour}%0D%0A%0D%0ALink%20to%20Para%20Tawny%20Timeline:%0D%0Ahttps://www.seppeltsfield.com.au/index.php/about/history/langtons-para-tawny-timeline${url}`} title="Send email">
                <img src={mail} className="socials socials--mail" alt="mail" />
              </a>
            </li>
          </ul>
        </div>
        <div className="product__details">
          {!!(hit.year_placed_into_barrels)
            ?
            <div className="detail detail--barrel">
              <h3>Barrel</h3>
              <p>Placed in Barrel: {hit.year_placed_into_barrels}
                {/* <Highlight attributeName="year_placed_into_barrels" hit={hit}/> */}
              </p>
            </div>
            :
              ""}
          {!!(hit.year_first_released)
            ?
              <div className="detail detail--release">
                <h3>Release</h3>
                <p>First released: {hit.year_first_released}
                </p>
              </div>
            :
              ""}
          <div className="detail detail--packaging">
            <h3>Packaging</h3>
            <p>{hit.bottle_sizes}</p>
            <p>{hit.bottling_information}</p>
            <p>{hit.bottle_shape_or_colour}</p>
          </div>
        </div>
        <div className="product__details product__details--last">
        {!!(hit.more_about_this_wine)
          ?
          <div className="detail detail--more-about-wine">
            <h3>More about this wine</h3>
            <p>{hit.more_about_this_wine}</p>
          </div>
          :
          ""}

        {!!(hit.attachment_filename_everything_before_pdf)
          ?
          <div className="detail detail--more-about-wine detail--download">
            <p>
            <a href={`https://www.seppeltsfield.com.au/zhistory/files/${hit.attachment_filename_everything_before_pdf}.pdf`} className="product__details--download__link" target="_blank">
              <img src={download} className="detail--download__icon" alt="download-button" />
              <span>Download {hit.attachment_title}</span>
              </a>
            </p>
          </div>
          :
          ""}
        {!!(hit.audio_filename_all_in_mp3_format)
          ?
          <div className="detail detail--more-about-wine detail--audio">
            <h3>{hit.audio_title}</h3>
            <p>{hit.audio_description}</p>
            <p>
            <audio
              controls
              src={`https://www.seppeltsfield.com.au/zhistory/audio/${hit.audio_filename_all_in_mp3_format}.mp3`}
              className="product__details--audio__link">
              Your browser does not support the
              <code>audio</code> element.
            </audio>
            </p>
          </div>
          :
          ""}
      </div>
      </div>
      {isOpen &&
        <Lightbox
          mainSrc={`https://www.seppeltsfield.com.au/zhistory/${hit.image_file_name_all_in_png_format}.jpg`}
          imageLoadErrorMessage="Image unavailable"
          onCloseRequest={() => this.setState({ isOpen: false })}
          enableZoom={false}
          reactModalStyle={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)'
            },
            content: {
              position: 'absolute',
              top: '0px',
              left: '200px',
              right: '200px',
              bottom: '0px',
              border: '1px solid rgba(255, 255, 255, 0.75)',
              background: '#ffffff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              outline: 'none'
            }
          }}
        />
      }
    </article>
  );
};
};
export default HitComponent;



// WEBPACK FOOTER //
// ./src/components/HitComponent.js